exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "#judge{width:100%;height:100%;position:fixed;left:0;top:0;background:#fff}", "", {"version":3,"sources":["E:/websites/lvjinhui/Ljh_OS/PC端/ljh_OS_Online_fix_v2.0(1&2融合版)-使用/src/components/isPcOrPhone/isPcOrPhone.vue"],"names":[],"mappings":"AACA,OACE,WAAY,AACZ,YAAa,AACb,eAAgB,AAChB,OAAQ,AACR,MAAO,AACP,eAAoB,CACrB","file":"isPcOrPhone.vue","sourcesContent":["\n#judge {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tposition: fixed;\n\t\tleft: 0;\n\t\ttop: 0;\n\t\tbackground: #ffffff;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7ff06c30","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/isPcOrPhone/isPcOrPhone.vue
// module id = 5jCd
// module chunks = 9